<template>
    <div class="assignment">
        <!-- 搜索 -->
        <div class="key_top">
            <ul class="key_list">
                <li class="conditions_list_item" style="overflow:visible">
                    <span>部门：</span>
                    <el-input @focus="departpopshow=!departpopshow" v-model="search.storeName" placeholder="请选择所在部门" clearable @clear="search.storeName='',search.storeId='',getTask('search')"></el-input>
                    <div class="departpop" v-show="departpopshow">
                        <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps" @node-click="handleNodeClick">
                            <span class="custom-tree-node" slot-scope="{ node,data}">
                                <div>
                                    <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                                    <span>{{ data.name }}</span>
                                </div>
                            </span>
                        </el-tree>
                    </div>
                    <!-- <el-select v-model="search.storeId" placeholder="请选择" clearable @change="getTask('search')">
            <el-option v-for="(item,index) in storeList" :key="index" :label="item.name" :value="item.storeId"></el-option>
                    </el-select>-->
                </li>
                <li class="conditions_list_item">
                    <span>执行人：</span>
                    <el-input v-model="search.executorName" placeholder="请输入执行人" clearable @input="getTask('search')"></el-input>
                </li>
                <li class="conditions_list_item">
                    <span>状态：</span>
                    <el-select v-model="search.status" placeholder="请选择" clearable @change="getTask('search')">
                        <el-option v-for="(item,index) in statusList" :key="index" :label="item.name" :value="item.status"></el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item">
                    <span>类型：</span>
                    <el-select v-model="search.type" placeholder="请选择" clearable @change="getTask('search')">
                        <el-option v-for="(item,index) in taskTypeList" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item">
                    <span>签约日期：</span>
                    <span class="total_inp">
                        <el-date-picker v-model="search.date" unlink-panels @change="getTask('search')" value-format="yyyy-MM-dd" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
                    </span>
                </li>
            </ul>
        </div>
        <!-- 表格 -->
        <div class="key_list_wrap">
            <div class="sales_list_wrap">
                <el-table :data="taskList" border style="width: 100%;" :header-cell-style="setHeaderStyle" highlight-current-row @row-click="rowColorclick">
                    <el-table-column prop="beginDate" label="开始时间"></el-table-column>
                    <el-table-column prop="endDate" label="结束时间"></el-table-column>
                    <el-table-column prop="executoName" label="执行人"></el-table-column>
                    <el-table-column prop="type" label="类型"></el-table-column>
                    <el-table-column prop="status" label="状态"></el-table-column>
                    <el-table-column prop="taskContent" label="任务描述" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="storeName" label="部门" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="icon" label="关联">
                        <template slot-scope="scope">
                            <i class="iconfont icon-icon_fangyuan_liang" :class="{rowColor:scope.row.id===isRowColor}" style="color:#5E75E6;padding:5px 50px;cursor:pointer;font-size:22px;" v-if="scope.row.icon=='HOUSE'" @click="goHouse(scope.row.detailId,scope.row.employeeId,scope.row.housingProperty)"></i>
                            <i class="iconfont icon-icon_keyuan_liang" :class="{rowColor:scope.row.id===isRowColor}" style="color:#5E75E6;padding:5px 50px;cursor:pointer;font-size:22px;" v-if="scope.row.icon=='CUSTOMER'" @click="goCustomer(scope.row.detailId,scope.row.employeeId)"></i>
                            <i class="iconfont icon-hetong1" :class="{rowColor:scope.row.id===isRowColor}" style="color:#5E75E6;padding:5px 50px;cursor:pointer;font-size:22px;" v-if="scope.row.icon=='CONTRACT'" @click="goContract(scope.row.detailId,scope.row.employeeId)"></i>
                            <i class="iconfont icon-quanzheng1" :class="{rowColor:scope.row.id===isRowColor}" style="color:#5E75E6;padding:5px 50px;cursor:pointer;font-size:22px;" v-if="scope.row.icon=='WARRANT'" @click="goWarrant(scope.row.detailId,scope.row.employeeId)"></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="employeeName" label="创建人"></el-table-column>
                    <el-table-column prop="operationTime" label="创建时间"></el-table-column>
                </el-table>
            </div>

            <div class="footer_pagemage">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { dicGet } from "@/api";
import { storeFind, departmentFind } from "@/api/manageCenter";
import { task } from "@/api/assignment";
export default {
    // name: "任务管理",
    name: "/assignment",
    data() {
        return {
            departpopshow: false,
            defaultProps: {
                children: "child"
            },
            departmentList: [], //门店列表
            taskList: [], //列表
            statusList: [
                { status: "TO_BE_AUDITED", name: "待处理" },
                { status: "AUDITED", name: "已完成" },
                { status: "UNABLE", name: "已作废" },
                { status: "END", name: "已拒绝" }
            ], //状态列表
            taskTypeList: [], //类型列表
            pickerOptions: {
                shortcuts: [
                    {
                        text: "当天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            //搜索
            search: {
                storeId: "", //门店编号
                storeName: "", //门店名字
                executorName: "", //执行人姓名
                status: "", //状态
                type: "", //任务类型
                date: "", //时间
                "page.pageNumber": "", //从第几条开始
                "page.pageSize": "" //显示几条
            },
            pageNumber: 1,
            pageSize: 20,
            total: 0,
            currentPage: 1,
            isRowColor: ""
        };
    },
    mounted() {
        this.isRowColor = "";
        this.getTask(); //查询列表
        this.getdepartmentFindAll(); //查询门店
        this.getTaskTypeList(); //查询类型
    },
    activated() {
        this.isRowColor = "";
        this.getTask(); //查询列表
        this.getdepartmentFindAll(); //查询门店
        this.getTaskTypeList(); //查询类型
    },
    methods: {
        //修改当前行字体颜色
        rowColorclick(row) {
            this.isRowColor = row.id;
        },
        //表单头部颜色
        setHeaderStyle() {
            return "background-color: #F2F4FF";
        },
        //跳转房源详情
        goHouse(buildId, employeeId, type) {
            if (type == "SECONDHAND") {
                sessionStorage.setItem("sellHousebuildId", buildId);
                this.$router.push({ path: "/buildDetail" });
            } else if (type == "RENTING") {
                sessionStorage.setItem("rentHousebuildId", buildId);
                this.$router.push({ path: "/rentingBuildDetail" });
            } else if (type == "SHOP_SALE") {
                sessionStorage.setItem("sellShopbuildId", buildId);
                this.$router.push({ path: "/sellShopDetails" });
            } else if (type == "SHOP_RENTAL") {
                sessionStorage.setItem("rentShopbuildId", buildId);
                this.$router.push({ path: "/rentShopDetails" });
            }
            sessionStorage.setItem("buildId", buildId);
            sessionStorage.setItem("employeeId", employeeId);
        },
        //跳转客源详情
        goCustomer(customerId, employeeId) {
            localStorage.setItem("customerId", customerId);
            sessionStorage.setItem("employeeId", employeeId);
            this.$router.push("/purchaseDetail");
        },
        //跳转合同详情
        goContract(id, employeeId) {
            sessionStorage.setItem("contractId", id);
            sessionStorage.setItem("employeeId", employeeId);
            this.$router.push({ path: "/contractDetails" });
        },
        //跳转权证详情
        goWarrant(id, employeeId) {
            sessionStorage.setItem("warrantId", id);
            sessionStorage.setItem("warrantEmployeeId", employeeId);
            this.$router.push({ path: "/warrantDetalis" });
        },
        //获取类型列表
        getTaskTypeList() {
            let params = {
                code: "taskType"
            };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.taskTypeList = res.data;
                }
            });
        },
        handleNodeClick(node, data) {
            //cosole.log(node)
            this.search.storeId = node.id;
            this.search.storeName = node.name;
            this.getTask("search");
            this.departpopshow = false;
        },
        // 获取门店列表
        getdepartmentFindAll() {
            // 获取部门
            this.$post(departmentFind).then(res => {
                if (res.success) {
                    this.departmentList = res.data;
                }
            });
        },
        //查询列表
        getTask(flag) {
            if (flag == "search") {
                this.pageNumber = 1;
                this.currentPage = 1;
            }
            let level = "";
            let menu = JSON.parse(localStorage.getItem("menu"));
            if (menu)
                menu.map(item => {
                    if (item.name == "任务管理") {
                        item.childMenus.map(child => {
                            if (child.name == "任务管理") {
                                child.functions.map(func => {
                                    if (func.functionName == "任务查看") {
                                        level = func.level;
                                    }
                                });
                            }
                        });
                    }
                });
            let params = Object.assign({}, this.search);
            params.permissionLevel = level;
            params["page.pageNumber"] =
                this.pageNumber * this.pageSize - this.pageSize;
            params["page.pageSize"] = this.pageSize;
            this.$post(task, params).then(res => {
                if (res.success) {
                    this.taskList = res.data;
                    this.taskList.map((item, index) => {
                        if (item.status) {
                            if (item.status == "TO_BE_AUDITED") {
                                item.status = "待处理";
                            } else if (item.status == "AUDITED") {
                                item.status = "已完成";
                            } else if (item.status == "UNABLE") {
                                item.status = "已作废";
                            } else if (item.status == "END") {
                                item.status = "已拒绝";
                            }
                        }
                    });
                    this.total = res.total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.getTask(); //每页显示条数
        },
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.getTask(); //当前页
        }
    }
};
</script>
<style lang="less">
.assignment {
    .key_list {
        display: flex;
        .conditions_list_item {
            display: flex;
            align-items: center;
            margin-right: 20px;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            > span {
                line-height: 20px;

                font-size: 12px;
            }
            .el-input {
                width: 150px;
                height: 30px;

                .el-input-group__append,
                .el-input-group__prepend {
                    padding: 0 10px;
                }

                .el-input__inner {
                    height: 30px;
                }

                .icon-icon_sousuo {
                    color: white;
                }
            }
            .el-select {
                margin-left: 10px;
                .el-input {
                    width: 100px;
                    .el-input__inner {
                        width: 100px;
                        height: 30px;
                        color: black;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
            .total_inp {
                display: flex;
                align-items: center;
                .el-range-editor.el-input__inner {
                    height: 30px;
                    line-height: 30px;
                    .el-range-separator {
                        height: 30px;
                        line-height: 30px;
                    }
                    .el-input__icon {
                        height: 30px;
                        line-height: 30px;
                    }
                }
            }
        }
    }
    .departpop {
        width: 170px;
        position: absolute;
        left: 60px;
        top: 41px;
        z-index: 10;
        border: 1px solid #eee;
        .tree-item {
            display: flex;
            align-items: center;
            img {
                padding-right: 10px;
            }
        }
    }
    .footer_pagemage {
        display: flex;
        justify-content: flex-end;
        margin: 20px 0;

        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #5e75e6;
        }

        .el-pagination.is-background .btn-next,
        .el-pagination.is-background .btn-prev,
        .el-pagination.is-background .el-pager li {
            border: 1px solid #ccc;
            background: white;
        }
    }
}
</style>
<style lang='less' scoped>
.assignment {
    overflow-y: none;
    .el-table .cell,
    .el-table th div,
    .el-table--border td:first-child .cell,
    .el-table--border th:first-child .cell {
        text-align: center;
    }

    .key_top {
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 30px;
        background: #fff;

        .add_btn {
            width: 100px;
            height: 30px;
            background: #5e75e6;
            color: white;
            outline: none;
            border: none;
        }
    }
    .key_list_wrap {
        // height: 90%;

        .el-dialog {
            width: 600px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }
    }
}
</style>